import ConfirmEmail from 'src/components/features/forgotPassword/ConfirmEmail';

const ConfirmEmailPage = () => <ConfirmEmail />;

export default ConfirmEmailPage;
